import CryptoJS from "crypto-js";
import md5 from "md5";
import { information } from "../const/info.const";

// Encrypt function
export const encrypt = (text: string): string => {
  const { key_free } = information;
  const md5Key = md5(key_free).toLowerCase();
  const cipherText = CryptoJS.AES.encrypt(text, md5Key).toString();
  return cipherText;
};

// Decrypt function
export const decrypt = (cipherText: string): string => {
  const { key_free } = information;
  const md5Key = md5(key_free).toLowerCase();
  const bytes = CryptoJS.AES.decrypt(cipherText, md5Key);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};
